<div *ngIf="labels && !showPointTransfer" class="ui-g ui-fluid form-group master-data customer-cards-info">

  <div class="barcodeContainer" style="height: 0;visibility: hidden;">
    <svg id="barcode" style="height: 0;"></svg>
  </div>

  <p-panel *ngFor="let card of cards;let i=index;" class="ui-g-12 ui-md-4 {{ card.isBlacklisted ? 'blacklisted' : '' }}  {{ card.isUnlinked && !customerMgPermission ? 'unlinked' : '' }} {{ card.isDisabled ? 'disabled' : '' }}">
    <p-header>
      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">{{ labels.cardType }}: {{ card.cardType }}</span>

        <div class="ui-button-title" *ngIf="!card.isBlacklisted">
          <button pButton *ngIf="!card.isUnlinked && !customerMgPermission && cardViewPermissionCheck" type="button" class="ui-button-primary btnDelete" style="background-color:#2399e5;" icon="fa fa-eye" (click)="goToCardDetail(card)" pTooltip="{{ 'customers.loyalty_card_detail' | translate }}"></button>
          <button pButton *ngIf="showBtnSubstitutePermission && cardOperationsPermission" type="button"
            class="ui-button-warning btnDelete" icon="fa fa-retweet" (click)="showReplaceCardModal(card)"
            pTooltip="{{ (customerMgPermission && !allCustomerMandatoryFieldsOk) ? labels.replaceCardCustomerIncomplete : labels.replaceCardCustomer.replace('{cartno}', '')}}"
            [ngClass]="{'substitutionBtnDisabled' : !showBtnSubstitutePermission}">
          </button>
          <button pButton *ngIf="((customerMgPermission && (card.isUnlinked || !card.isMaster)) || (!card.isUnlinked && !customerMgPermission)) && cardOperationsPermission"
            type="button" class="ui-button-blacklist btnDelete" icon="fa fa-ban" (click)="showBlackListCardModal(card)"
             pTooltip="{{ labels.blacklistCardCustomer.replace('{cartno}', '') }}">
          </button>
          <button pButton *ngIf="(customerMgPermission || (!card.isUnlinked && !customerMgPermission)) && cardOperationsPermission" type="button" class="ui-button-info btnDelete" icon="fa fa-credit-card" (click)="showDomiciliation(card)" pTooltip="{{labels.domiciliation}}"></button>
          <button pButton type="button" *ngIf="addMovementsPermission && (customerMgPermission || (!card.isUnlinked && !customerMgPermission))" class="ui-button-success btnDelete" icon="fa fa-arrows" (click)="showAddMovement(card)" pTooltip="{{labels.addMovement}}"></button>
          <button pButton type="button" *ngIf="card.isUnlinked && cardOperationsPermission && !customerMgPermission" icon="fa fa-link" style="background-color:#2399e5;" pTooltip="{{labels.linkCard}}" (click)="linkCard(card.cardId)"></button>
          <button pButton type="button" *ngIf="!card.isUnlinked && card.cardLinkStatus !== '2'&& cardOperationsPermission && !customerMgPermission" icon="fa fa-unlink" style="background-color: #ff6600;" pTooltip="{{labels.unlinkCard}}" (click)="unlinkCard(card.cardId)"></button>
          <button pButton type="button" *ngIf="card.flg_state == 'D' && cardOperationsPermission && showBtnEnableCardPermission" icon="fa fa-check" style="background-color: #3eb952;" pTooltip="{{labels.enableCard}}" (click)="enableCard(card)"></button>

          <!-- Link Card Buttons per Gabrielli -->
          <button pButton type="button" *ngIf="!card.isUnlinked && cardOperationsPermission && customerMgPermission" icon="fa fa-link" style="background-color:#2399e5;" pTooltip="{{'customers.linkedCard' | translate}}" (click)="goToMgLinkCard(card.cardNo)"></button>
          <button pButton type="button" *ngIf="card.isUnlinked && cardOperationsPermission && customerMgPermission" icon="fa fa-unlink" style="background-color: #ff6600;" pTooltip="{{'customers.unlinkedCard' | translate}}" (click)="goToMgLinkCard(card.cardNo)"></button>

          <!-- Button balances -->
         <span *ngIf="card.flagBlackList !== '1' && card.flg_state !== '1' && reservationPermission" pTooltip="{{labels.balances}}" (click)="goToBalances(card.vCustomerId)">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="565.000000pt"
            height="557.000000pt"
            viewBox="0 0 565.000000 557.000000"
            preserveAspectRatio="xMidYMid meet"
            pTooltip="{{labels.balances}}"
            *ngIf="card.flagBlackList !== '1' && card.flg_state !== '1'"
            (click)="goToBalances(card.vCustomerId)"
            class="button-saldi">
            <g transform="translate(0.000000,557.000000) scale(0.100000,-0.100000)"
            fill="#2b4579" stroke="none">
            <path d="M1692 5493 c-68 -33 -103 -115 -82 -188 7 -22 128 -214 269 -427
            l256 -388 685 0 685 0 256 388 c141 213 262 404 268 425 23 69 -13 153 -80
            187 -37 20 -63 20 -1131 20 -988 0 -1096 -2 -1126 -17z"/>
            <path d="M2025 4081 c-694 -421 -1174 -880 -1519 -1450 -158 -261 -292 -595
            -357 -893 -43 -196 -53 -305 -54 -563 0 -230 2 -257 23 -333 61 -224 201 -420
            399 -562 136 -96 259 -152 448 -203 l80 -22 1720 -3 c1190 -2 1745 0 1803 8
            478 63 880 409 968 836 23 112 15 497 -15 669 -101 585 -341 1085 -757 1575
            -91 107 -341 353 -459 451 -224 187 -440 341 -678 483 l-128 76 -682 -1 -682
            -1 -110 -67z m920 -803 c43 -19 55 -56 55 -166 l0 -99 72 -12 c84 -14 183 -51
            253 -97 49 -31 75 -66 75 -102 0 -19 -161 -183 -198 -201 -19 -10 -32 -8 -80
            16 -57 28 -58 28 -287 31 -217 3 -232 2 -263 -18 -83 -51 -83 -211 0 -264 13
            -8 147 -51 298 -96 151 -45 304 -96 339 -113 82 -40 186 -142 229 -223 136
            -261 27 -577 -243 -705 -33 -16 -75 -31 -92 -34 -18 -3 -49 -7 -68 -10 l-35
            -6 0 -104 c0 -102 -1 -106 -29 -137 l-29 -33 -121 0 c-118 0 -121 1 -148 28
            -27 26 -28 33 -33 140 l-5 112 -50 6 c-111 14 -233 65 -305 126 -65 56 -59 78
            53 184 50 49 100 92 110 95 11 3 45 -6 80 -23 61 -28 64 -28 282 -31 195 -2
            224 -1 254 15 98 51 94 232 -6 276 -21 10 -155 51 -298 93 -301 88 -371 120
            -462 212 -155 157 -194 378 -101 574 77 161 226 271 399 294 l49 7 0 109 c0
            108 0 110 29 139 29 29 31 29 140 29 64 0 121 -5 136 -12z"/>
            </g>
          </svg>
          </span>
          <!-- Fine Button Balances -->
        </div>
      </div>
    </p-header>

    <div class="ui-g-12 ui-fluid" *ngIf="show.cardsRendered">
      <div class="ui-g-4">
        <label>{{ labels.cardNo }}</label>
        <span>{{ card.cardNo }}</span>
        <label>Flag Deploy</label>
        <span>{{ card.flg_dpl }}</span>
      </div>
      <div class="blacklist-data ui-g-8" *ngIf="card.isBlacklisted">
        <label>{{ labels.blacklisted }}</label>
        <span>{{ labels.reason }}: {{ card.reasonDescription }}</span><br>
        <span>{{ labels.blacklistedOn }}: {{ card.blackListDate | date:'dd/MM/yyyy' }} {{ card.blackListTime | date:'HH:mm' }}</span>
      </div>
      <div class="blacklist-data ui-g-8" *ngIf="card.flg_state === 'D'">
        <label>{{ labels.disabledCard }}</label>
      </div>
      <div class="blacklist-data ui-g-8" *ngIf="card.cardLinkStatus === '7'">
        <label>{{ labels.unlinkedCard }}</label>
      </div>
      <div *ngIf="customerMgPermission">
        <div class="barcodeContainer ui-g-12 text-center">
          <svg id="barcode{{i}}"></svg>
        </div>
      </div>
    </div>
  </p-panel>
  <div class="clearfix"></div>

  <p-panel *ngIf="customerMgPermission && showAddCards" class="ui-g-12 ui-md-4">
    <p-header>

      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">{{ labels.addCard }}</span>
      </div>

    </p-header>

    <div class="ui-g-12 ui-fluid">
      <div class="ui-g-12">
        <span>{{ labels.addCardCustomer }}</span>
        <br><br>
        <button
        [ngClass]="{'addBtnDisabled' : !allCustomerMandatoryFieldsOk}"
        pTooltip="{{ (customerMgPermission && !allCustomerMandatoryFieldsOk) ? labels.replaceCardCustomerIncomplete : labels.addCard }}"
        pButton type="button" class="ui-button-success" icon="fa fa-plus" (click)="showLinkCardModal()"></button>
      </div>
    </div>
  </p-panel>

  <p-panel *ngIf="!customerMgPermission" class="ui-g-12 ui-md-4">
    <p-header>

      <div class="ui-helper-clearfix">
        <span class="ui-panel-title">{{ labels.addCard }}</span>
      </div>

    </p-header>

    <div class="ui-g-12 ui-fluid">
      <div class="ui-g-12">
        <span>{{ labels.addCardCustomer }}</span>
        <br><br>
        <button pButton type="button" class="ui-button-success" icon="fa fa-plus" (click)="showLinkCardModal()" pTooltip="{{ labels.addCard }}"></button>
      </div>
    </div>
  </p-panel>

  <div class="clearfix"></div>



  <p-dialog header="{{ labels.addCardCustomer }}" [(visible)]="showLinkModal" [modal]="true" [draggable]="false" [resizable]="false" [width]="700">
    <div class="ui-dialog-content">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12">
          <span class="label">{{ labels.selectCardCustomer }}</span>
          <p-autoComplete [(ngModel)] = "cardToAdd"
                          [suggestions]="cardsModal"
                          (completeMethod)="filterCardSingle($event)"
                          (onSelect)="cardIdSelect($event)"
                          placeholder="Select..."
                          [minLength]="2" field="cardNo">
            <ng-template let-card pTemplate="item">
              <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                <div>{{ card.cardNo }}</div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="ui-g-12">
          <span class="label">{{ 'customerDetail.domiciliationStores' | translate }}</span>
          <p-dropdown
            [filter]="true"
            [options]="stores"
            [style]="{'width':'100%' }"
            [(ngModel)]="userStore"
            [disabled]="stores && stores.length === 1">
          </p-dropdown>
        </div>
      </div>
    </div>

    <div class="ui-dialog-footer">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-plus" iconPos="left" (click)="addCard()" label="{{ 'common.add' | translate }}" [disabled]="!this.cardToAdd || !this.userStore"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left" (click)="showLinkModal = false" label="{{ 'common.cancel' | translate }}"></button>
    </div>
  </p-dialog>

  <p-dialog header="{{ labels.blacklistCardCustomer.replace('{cartno}', cardToBlacklistNo) }}" [(visible)]="showBlackListModal" [modal]="true" [draggable]="false" [resizable]="false">
    <div class="ui-dialog-content">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6">
          <span class="label">{{ labels.selectBlacklistReason }}</span>
          <p-dropdown [options]="blacklistReasons" [(ngModel)]="selectedBlacklistReason" placeholder="Select..." #blacklistReason></p-dropdown>
        </div>
      </div>
    </div>
    <div class="ui-dialog-footer" *ngIf="showBlackListModal">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-ban"
              (click)="blacklistCard(blacklistReason)" label="Blacklist" [disabled]="!selectedBlacklistReason"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" (click)="closeBlacklistModal()" label="Cancel"></button>
    </div>
  </p-dialog>

  <p-dialog
  *ngIf="showReplaceModal"
  header="{{ labels.replaceCardCustomer.replace('{cartno}', cardToReplace == null ? '': cardToReplace.cardNo) }}"
  [(visible)]="showReplaceModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeReplaceModal(replaceReason)">
    <div class="ui-dialog-content">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12">
          <span class="label">{{ labels.selectCardCustomer }}</span>
          <p-autoComplete [(ngModel)] = "newCardReplace"
                          [suggestions]="cardsModal"
                          [delay]="600"
                          (completeMethod)="filterCardSingle($event)"
                          (onSelect)="cardReplaceIdSelect($event)"
                          placeholder="Select..."
                          [minLength]="2" field="cardNo">
            <ng-template let-card pTemplate="item">
              <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                <div>{{ card.cardNo }}</div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12 ui-md-6">
          <span class="label">{{ labels.replaceReason }}</span>
          <p-dropdown
          [options]="substitutionReasons"
          placeholder="Select..."
          (onChange)="reasonSelectedHandler()"
          #replaceReason></p-dropdown>
        </div>
      </div>
      <div class="ui-g" *ngIf="show.substitutionOk">
        <div class="ui-g-12">
          <span class="label" style="color:green">{{'card.substitution_ok' | translate}}</span>
        </div>
      </div>


    </div>

    <div class="ui-dialog-footer">
      <button
      *ngIf="customerMgPermission"
      [disabled]="!show.downloadSubstituteModule"
      type="button"
      pButton
      pTooltip="{{'upload.download_file' | translate}}"
      class="ui-button-warning btnDelete"
      icon="fa fas fa-file"
      iconPos="left"
      [ngClass]="{'substitutionBtnDisabled' : !show.downloadSubstituteModule}"
      (click)="onClickScaricaModuloVuoto()"
      label="Download"></button>

      <button
      [disabled]="show.downloadSubstituteModule || !substitutionDisabled.cardSelected || !substitutionDisabled.reasonSelected"
      type="button"
      pButton
      [ngClass]="{'substitutionBtnDisabled' : !substitutionDisabled.cardSelected || !substitutionDisabled.reasonSelected || show.downloadSubstituteModule}"
      class="ui-button-success btnDelete"
      icon="fa fa-retweet"
      iconPos="left"
      (click)="confirm(replaceReason)"
      label="{{ 'card.replace' | translate }}"></button>

      <button
      type="button"
      pButton
      class="ui-button-danger btnDelete"
      icon="fa fa-close"
      iconPos="left"
      (click)="closeReplaceModal(replaceReason)"
      label="{{ 'common.cancel' | translate }}"></button>
    </div>
  </p-dialog>
  <p-confirmDialog key="conferma"></p-confirmDialog>

  <p-dialog *ngIf="selectedCard && filteredStoresByChannel && currentStore"
            header="{{ 'card.domiciliation' | translate }}"
            (onHide)="undoDomiciliation()"
            [(visible)]="showDomiciliationModal"
            [modal]="true"
            [draggable]="false"
            [resizable]="false">
    <kv-card-domiciliation
      [card]="selectedCard"
      [filteredStores]="filteredStoresByChannel"
      [currentStore]="currentStore"
      (onCancel)="undoDomiciliation()"
      (onSave)="performDomiciliation($event)"
    ></kv-card-domiciliation>
  </p-dialog>

</div>

<div *ngIf="!showPointTransfer" class="ui-g form-group master-data">

<app-kontable *ngIf="balances && balances.length > 0"
    id="dt_shopping"
    title="{{ 'customers.saldi' | translate }}"
    [columns]="[
      'id',
      'card_no',
      'customAccumulator',
      'customChannel',
      'value',
      'value_2',
      { field: 'date_expiration', bodyTemplate: expDateTemplate, title: 'customerDetail.expirationDate' }
    ]"
    [titles]="[labels.accumulator_id, labels.cardNo, labels.accumulator,labels.channel,labels.value,labels.value_2]"
    [source]="balances"
    [showGlobalFilter]="false"
    [showDetailsButton]="movementsPermission"
    [showInfoButton]="false"
    [showRecoverButton]="false"
    [showAddButton]="false"
    [showEditButton]="false"
    [showDeleteButton]="false"
    (onDetails)="onDetail($event)"
    [additionalRowCommands]="commands"
    [paginationType]="paginationType"
>
  <ng-template #dateTemplateStart data-testid="dateTemplateStart" let-row>
    <span>{{row['date_start'] | date: 'yyyy-MM-dd' }}</span>
  </ng-template>
  <ng-template #dateTemplateEnd data-testid="dateTemplateEnd" let-row>
    <span>{{row['date_end'] | date: 'yyyy-MM-dd' }}</span>
  </ng-template>
  <ng-template #commands data-testid="commands" let-row *ngIf="pointsPermission">
    <p-button pTooltip="{{ 'loyalty.transfer_point' | translate }}" icon="fa fas fa-exchange" styleClass="ui-button-info" (onClick)="onPointTransfer(row)"></p-button>
  </ng-template>
  <!-- Expiration Date Template -->
  <ng-template #expDateTemplate data-testid="expDateTemplate" let-row let-value="value">{{value | date: srvCalTranslate.pcalendarTranslate.dateFormatFilter }}</ng-template>
</app-kontable>

</div>
<p-dialog *ngIf="showDetails && currentAccumlatorId"
          header="{{ 'customers.loyalty_movements' | translate }}"
          (onHide)="showDetails = false"
          [(visible)]="showDetails"
          [modal]="true"
          [style]="{ width: '100% !important', height: '100% !important', overflow: 'scroll !important' }"
          [draggable]="false"
          [contentStyle]="{'overflow':'auto','height':'100%','width':'100%'}"
          [positionTop]="'0'"
          [positionLeft]="'0'"
          [resizable]="false">
  <kv-customer-loyalty-movements
    *ngIf="showDetails && currentAccumlatorId"
    [accumulatorId]="currentAccumlatorId"
    [customerHostId]="customerId"
    [cardNo]="cardNoSearchMov"
  >
  </kv-customer-loyalty-movements>
</p-dialog>
<kv-point-transfer
  *ngIf="showPointTransfer && transferSource"
  (onBack)="showPointTransfer = false"
  [transferSource]="transferSource"
  [customerSource]="vCustomer"
></kv-point-transfer>

<!-- modal per inserimento di un movimento -->
<p-dialog *ngIf="showAddMovementModal"
          header="{{ 'movement.add_title' | translate }}"
          [(visible)]="showAddMovementModal"
          [modal]="true"
          [draggable]="true"
          [positionTop]="50"
          [width]="800">
  <app-form-movement-loyalty
    [card_id]="movementCardId"
    (onSaved)="movementSaved($event)"
    (onCardNotFound)="cardNotFoundHandler()"
  ></app-form-movement-loyalty>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/loyaltyinfo.component.html